import Vue from 'vue'

export default Vue.extend({
  computed: {
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    }
  },
  mounted () {
    if (this.activeTeam !== '') this.$store.direct.dispatch.abilities.subscribeTeamRoles(this.activeTeam)
  },
  beforeDestroy () {
    if (this.activeTeam !== '') this.$store.direct.dispatch.abilities.unsubscribeTeamRoles(this.activeTeam)
  },
  watch: {
    activeTeam (newVal: string, oldVal: string) {
      if (oldVal !== '') this.$store.direct.dispatch.abilities.unsubscribeTeamRoles(oldVal)
      if (newVal !== '') this.$store.direct.dispatch.abilities.subscribeTeamRoles(newVal)
    }
  }
})
